import styled from 'styled-components';

export const StepIcon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${(props) =>
    props.accomplished
      ? props.isRejectedStatus
        ? 'red'
        : 'var(--color-blue-primary)'
      : 'white'};
  color: ${(props) =>
    props.accomplished ? 'white' : 'var(--color-blue-primary)'};
  width: 35px;
  height: 35px;
  border-radius: 50%;
  border: ${(props) =>
    props.accomplished ? 'none' : '1px solid var(--color-blue-primary)'};
`;
